import './auth.css';
import { useT } from 'i18n';
import SelectorIdioma from 'i18n/SelectorIdioma';

export const OK_RE = /éxito|exito|enviado|reenviado|verifique su correo|creado|correcta|cambiada/i;

export const Logo = () => (
  <div className="p7a-logo"><img src={`${process.env.PUBLIC_URL}/panther-gold.svg`} alt="Panther7" /></div>
);

export const Aviso = ({ texto, ok, children }) => (
  <div className={`p7a-aviso ${ok ? 'ok' : 'err'}`} role={ok ? 'status' : 'alert'}>
    <div>{texto}{children}</div>
  </div>
);

const AuthShell = ({ titulo, subtitulo, ancha, demo, children }) => {
  const { t } = useT();
  return (
  <main className="p7a">
    <div className="p7a-idioma"><SelectorIdioma /></div>
    {demo && <span className="p7a-demo">{t('comun.plataformaDemo')}</span>}
    <section className={`p7a-card${ancha ? ' ancha' : ''}`}>
      <a href="https://www.panther7.com" aria-label="Panther7"><Logo /></a>
      {titulo && <h1>{titulo}</h1>}
      {subtitulo && <p className="p7a-sub">{subtitulo}</p>}
      {children}
    </section>
  </main>
  );
};

export default AuthShell;
